import { render } from "./beranda-ubah-password.vue?vue&type=template&id=2b5e392a&scoped=true"
import script from "./beranda-ubah-password.vue?vue&type=script&lang=js"
export * from "./beranda-ubah-password.vue?vue&type=script&lang=js"

import "./beranda-ubah-password.vue?vue&type=style&index=0&id=2b5e392a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5e392a"]])

export default __exports__